import { atom } from 'recoil';

import { localStorageEffect } from '@/utils/atom';

export const closedHospitalPopupDayState = atom<string | null>({
  key: 'closedHospitalPopupDay',
  default: null,
  effects: [localStorageEffect('closedHospitalPopupDay')],
});

export const closedCommunityPopupDayState = atom<string | null>({
  key: 'closedCommunityPopupDay',
  default: null,
  effects: [localStorageEffect('closedCommunityPopupDay')],
});
